module.exports = __webpack_public_path__ + "img/77fa65d.png";